import React, { Component } from 'react';

import { withTranslation } from 'react-i18next';
import ReactSVG from 'react-svg';

import ChauffeurActivitiesTimelineContainer from '@containers/chauffeur/ChauffeurActivitiesTimelineContainer';
import UpdateChauffeurContainer from '@containers/chauffeur/crud/UpdateChauffeurContainer';

import Collapsible from '@uicomponents/Collapsible';
import Loader from '@uicomponents/Loader';

import ContactDetailsView from '../general/ContactDetailsView';
import NotesView from '../note/NotesView';
import DrivingTimes from './DrivingTimes';

class ChauffeurView extends Component {
  render() {
    const { t, chauffeur, isFetchingChauffeur, onChange, addToStack } =
      this.props;

    if (!chauffeur || isFetchingChauffeur) {
      return <Loader />;
    }
    return (
      <div className="chauffeur-view">
        <div className="flex-container justify-between no-wrap">
          <div>
            <div className="flex-container justify-between">
              <h1 className="no-margin-bottom with-flair">
                {chauffeur.firstName} {chauffeur.lastName}{' '}
                <span>{t(`chauffeurType.${chauffeur.type}`)}</span>
              </h1>
            </div>
            <h3 className="no-margin-top">#{chauffeur.id}</h3>
          </div>
          <div className="self-center flex-container action-icons">
            <div
              className="action-icon"
              onClick={(e) => {
                e.preventDefault();
                addToStack({
                  name: t('chauffeur.update.header'),
                  component: (
                    <UpdateChauffeurContainer
                      chauffeur={{ ...chauffeur }}
                      callback={(result) => {
                        onChange('chauffeur', result.chauffeur || {});
                      }}
                    />
                  ),
                });
              }}
            >
              <ReactSVG src="/icons/pencil.svg" />
            </div>
          </div>
        </div>

        <div>
          <b>{t('chauffeur.type')}</b>: {t(`chauffeurType.${chauffeur.type}`)}
        </div>

        <section className="margin-top">
          <DrivingTimes chauffeur={chauffeur} />
        </section>
        <section className="margin-top">
          <ChauffeurActivitiesTimelineContainer chauffeur={chauffeur} />
        </section>
        <section className="margin-top">
          <Collapsible
            name={`${t('notes.header')}${
              chauffeur.notes?.length > 0 ? ` (${chauffeur.notes?.length})` : ''
            }`}
            className="collapsible-element"
            defaultIsOpen={false}
          >
            <NotesView notes={chauffeur.notes} />
          </Collapsible>
          <Collapsible
            name={`${t('contactDetails.header')}${
              chauffeur.contactDetails.length > 0
                ? ` (${chauffeur.contactDetails.length})`
                : ''
            }`}
            className="collapsible-element"
            defaultIsOpen={false}
          >
            <ContactDetailsView contactDetails={chauffeur.contactDetails} />
          </Collapsible>
        </section>
      </div>
    );
  }
}
export default withTranslation('translation')(ChauffeurView);
